import ShopsDataTable from "../components/ShopsDataTable";

function ShopsPage() {
    return (
        <section>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h1 className="h4 mb-1">Ateliers</h1>
                    <p className="text-secondary mb-0">Liste paginée des ateliers.</p>
                </div>
            </div>

            <ShopsDataTable />
        </section>
    );
}

export default ShopsPage;
